import AccountDetail from "pages/account/detail";

interface Props {
  accountId: string;
}

export function MyAccountPresenter({ accountId }: Props): JSX.Element {
  return <AccountDetail accountId={accountId} isMyAccount={true} />;
}
